<!-- Sidenav -->
<div class="main-content main-touch-content height-100">
  <!-- Top navbar -->
  <app-touch-navbar></app-touch-navbar>
  <!-- Pages -->
  <router-outlet></router-outlet>
</div>
